import React, { CSSProperties, Fragment } from "react";
import Modal from "../Modal/Modal";
import ArtworkCreator from "./ArtworkCreator/ArtworkCreator";
import AppImage from "@/components/AppImage/AppImage";
import ArtworkCardDetails from "@/components/ArtworkCard/ArtworkCardDetails/ArtworkCardDetails";
import ArtworkActions from "@/components/ArtworkActions/ArtworkActions";
import { ImageIcon } from "../icons/image";
import { useAuth } from "@/context/AuthContext";
import { useModal } from "@/hooks/useModal";
import { ArtWork } from "@/models/models";

interface ImageCardProps {
  artwork: ArtWork;
  width?: string;
  height?: string;
  isModalEnabled?: boolean;
  styles?: CSSProperties;
  refreshArtworks?: () => void;
  onClick?: () => void;
}

const ArtworkCard = (props: ImageCardProps) => {
  const { user } = useAuth();
  const { isOpen, toggleModal } = useModal();

  const initialStyles = {
    width: props.width,
    height: props.height,
    ...props.styles,
  };

  const handleClick = () => {
    props.onClick?.();

    if (props.isModalEnabled) {
      toggleModal();
      return;
    }
  };

  return (
    <Fragment>
      <div
        className="w-1/2 sm:w-1/3 mx-auto overflow-hidden rounded-lg cursor-pointer box-border"
        style={initialStyles}
      >
        {props.artwork?.image ? (
          <AppImage
            onClick={handleClick}
            src={props.artwork.image}
            alt={props.artwork.title}
          />
        ) : (
          <span>
            <ImageIcon />
          </span>
        )}
      </div>

      {props.isModalEnabled && (
        <Modal
          width={"auto"}
          height={"auto"}
          showHeader={true}
          isOpen={isOpen}
          toggleModal={toggleModal}
          headerContent={<ArtworkCreator creator={user} />}
        >
          <div className="flex-1">
            <ArtworkCardDetails
              artwork={props.artwork}
              toggleModal={toggleModal}
              refreshArtworks={props.refreshArtworks}
            />
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ArtworkCard;
